export const endpoints = {
  searchDashboards: 'dashboard/search',

  dashboardItem: 'dashboard'
};
